import { BSC_RPC_URL } from '@/constants/bsc'
import { MYRIAD_USD1_ADDRESS, MYRIAD_USD1_DECIMALS } from '@/constants/myriad'
import { CHAIN_CONFIG } from '@/lib/api/relay'
import { BSC_USDT_ADDRESS } from '@/lib/predictfun/client'
import { readEthersErc20Balance } from '../evm'
import type { MarketBalance, MarketWalletProvider } from '../types'

export const myriadWalletProvider: MarketWalletProvider = {
	id: 'myriad',
	label: 'Myriad',
	direction: 'toMyriad',
	decimals: 18,
	chain: { chainId: CHAIN_CONFIG.bsc.id, currency: CHAIN_CONFIG.bsc.usdt },
	cashToken: {
		symbol: 'USDT',
		address: BSC_USDT_ADDRESS,
		decimals: 18,
	},
	resolveAddress: runtime => runtime.addressOverrides?.myriad ?? runtime.eoaAddress ?? undefined,
	balanceQueryKey: address => ['market-balance', 'myriad', address] as const,
	async readBalance(runtime): Promise<MarketBalance | null> {
		const address = this.resolveAddress(runtime)
		if (!address) return null

		const [cash, usd1] = await Promise.all([
			readEthersErc20Balance({
				rpcUrl: BSC_RPC_URL,
				tokenAddress: BSC_USDT_ADDRESS,
				account: address,
				decimals: 18,
				symbol: 'USDT',
			}),
			readEthersErc20Balance({
				rpcUrl: BSC_RPC_URL,
				tokenAddress: MYRIAD_USD1_ADDRESS,
				account: address,
				decimals: MYRIAD_USD1_DECIMALS,
				symbol: 'USD1',
			}),
		])

		return { platform: 'myriad', address, cash, secondary: { usd1 } }
	},
	async readTokenBalance(runtime, request) {
		const address = request.address ?? this.resolveAddress(runtime)
		if (!address) return null

		return readEthersErc20Balance({
			rpcUrl: BSC_RPC_URL,
			tokenAddress: request.tokenAddress,
			account: address,
			decimals: request.decimals,
			symbol: request.symbol ?? 'Token',
		})
	},
}
